const breakpoints = {
  keys: ['xxs', 'xs', 'sm', 'md', 'lg', 'xl'],
  values: {
    xxs: 0,
    xs: 340,
    sm: 600,
    md: 960,
    lg: 1280,
    xl: 1920,
  },
};

module.exports.breakpoints = breakpoints;
